<template>
  <div id="app" class="wrapper">
    <NavPage/>
    <IndexPage/>
  </div>
</template>

<script>
import IndexPage from "@/view/IndexPage";
import NavPage from "@/view/NavPage";
export default {
  name: 'App',
  components: {
    IndexPage,NavPage
  },
}
</script>

<style>
.wrapper{
  height: 100%;
  overflow: hidden;
}

*{
  padding: 0;
  margin: 0;
}

html,body,#app {
  height: 100%;
  overflow-x: hidden;
}

</style>
